module.exports = __webpack_public_path__ + "37ba7b92/img/cadBim.e369a02a.png";